import { call, takeLatest } from 'redux-saga/effects';

import { AnalyticsService, webServicesUtil } from 'cloak-file-sdk-web'
import { CREATE_GUEST_NEW_LANDING_USAGE_REQUEST, CREATE_GUEST_UNSUBSCRIBE_USAGE_REQUEST, CREATE_GUEST_UNSUBSCRIBE_SURVEY_USAGE_REQUEST, CREATE_GUEST_REG_USAGE_REQUEST } from '../reducers/newLandingReducer'


export function* createGuestNewLandingUsage({ payload: { email, campaignId } }) {
	console.log("in newLandingSaga createGuestNewLandingUsage email " + email)
	yield call( AnalyticsService.createGuestNewLandingUsage, email, campaignId )
}

export function* createGuestUnsubscribeUsage({ payload: { email, campaignId } }) {
	console.log("in newLandingSaga createGuestUnsubscribeUsage email " + email)
	yield call( AnalyticsService.createGuestUnsubscribeUsage, email, campaignId )
}

export function* createGuestUnsubscribeSurveyUsage({ payload: { email, campaignId, option } }) {
	console.log("in newLandingSaga createGuestUnsubscribeSurveyUsage email " + email)
	yield call( AnalyticsService.createGuestUnsubscribeSurveyUsage, email, campaignId, option )
}

export function* createGuestRegUsage({ payload: { email, campaignId } }) {
	console.log("in regSaga createGuestRegUsage email " + email)
	yield call( AnalyticsService.createGuestRegUsage, email, campaignId )
}

export function* newLandingSaga() {
	yield takeLatest( CREATE_GUEST_NEW_LANDING_USAGE_REQUEST, createGuestNewLandingUsage )
	yield takeLatest( CREATE_GUEST_UNSUBSCRIBE_USAGE_REQUEST, createGuestUnsubscribeUsage )
	yield takeLatest( CREATE_GUEST_UNSUBSCRIBE_SURVEY_USAGE_REQUEST, createGuestUnsubscribeSurveyUsage )
	yield takeLatest( CREATE_GUEST_REG_USAGE_REQUEST, createGuestRegUsage )
}
